import PropTypes from "prop-types";
import React, { useRef } from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import { Text } from "../../Text";
import { TextColors } from "../../constants";

import "./styles.scss";

/**
 * @deprecated
 * DO NOT REPLICATE THIS PATTERN
 */
export const CheckboxOld = ({ version, ...props }) => {
  if (version === "v1") {
    return <CheckboxV1 {...props} />;
  } else if (version === "v2") {
    return <CheckboxV2 {...props} />;
  } else {
    console.error(`Invalid checkbox version ${version}`);

    return null;
  }
};

CheckboxOld.propTypes = {
  version: PropTypes.string,
};

CheckboxOld.defaultProps = {
  version: "v1",
};

const CheckboxV2 = ({
  checkboxContainerClassName,
  checked,
  className,
  disabled,
  inputClassName,
  label,
  labelClassName,
  labelColor,

  name,
  onChange,
  onClick,

  onFocus,

  value,

  ...props
}) => {
  // This adds the functionality of being able to select the button by clicking the text or the checkbox
  const onClickHandler = (e) => {
    onClick(e);
  };

  const inputElement = useRef();
  const checkboxContainerClass = disabled
    ? [
        "apti-CL",
        "apti-CheckboxContainer",
        "apti-CheckboxContainer--disabled",
        checkboxContainerClassName,
      ]
    : ["apti-CL", "apti-CheckboxContainer", checkboxContainerClassName];

  return (
    <div className={createClassNameString(["apti-CL", className])}>
      <div
        className={createClassNameString(checkboxContainerClass)}
        onClick={() => {
          onClickHandler({ target: inputElement?.current });
          onChange({ target: inputElement?.current });
        }}
      >
        <input
          checked={checked}
          className={createClassNameString(["apti-CL", "apti-Checkbox", inputClassName])}
          disabled={disabled}
          name={name}
          onFocus={onFocus}
          ref={inputElement}
          type="checkbox"
          value={value}
          {...props}
        />
        {label && (
          <Text className={createClassNameString([labelClassName])} color={labelColor}>
            {label}
          </Text>
        )}
      </div>
    </div>
  );
};

const CheckboxV1 = ({
  checked,
  className,
  disabled,
  name,
  onChange,
  onClick,
  onFocus,
  ...props
}) => {
  const onClickHandler = (e) => {
    onClick(e);
  };

  return (
    <input
      checked={checked}
      className={createClassNameString(["apti-CL", "apti-Checkbox", className])}
      disabled={disabled}
      name={name}
      onChange={onChange}
      onClick={onClickHandler}
      onFocus={onFocus}
      type="checkbox"
      {...props}
    />
  );
};

const checkboxV1PropTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  inputClassName: PropTypes.string,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  labelColor: PropTypes.oneOf([
    TextColors.grey,
    TextColors.green,
    TextColors.black,
    TextColors.red,
    TextColors.navy,
    TextColors.purple,
    TextColors.white,
  ]),
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  value: PropTypes.string,
};

const defaultV1Props = {
  checked: false,
  className: undefined,
  disabled: false,
  inputClassName: undefined,
  label: undefined,
  labelClassName: undefined,
  labelColor: TextColors.grey,
  name: "",
  onChange: () => {},
  onClick: () => {},
  onFocus: () => {},
  value: undefined,
};

CheckboxV1.propTypes = checkboxV1PropTypes;
CheckboxV1.defaultProps = defaultV1Props;

CheckboxV2.propTypes = checkboxV1PropTypes;
CheckboxV2.defaultProps = defaultV1Props;
